PJQ.views.comments = {};

PJQ.views.comments.CommentsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-add-comment'),
		onAddComment: null,
		onCancel: null
	},
	events: {
		'keyup .textarea-comment': 'commentChanged',
		'click .btn-add-comment': 'addComment'
	},
	commentChanged: function () {
		this.$('.btn-add-comment').prop('disabled', _.size(this.$('.textarea-comment').val()) === 0);
	},
	addComment: function () {
		if (typeof this.options.onAddComment === 'function') {
			this.options.onAddComment(this.$('.textarea-comment').val());
		}
		this.removeModal();
	}
});